import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    minWidth: 'auto',
    padding: '5px 15px',
    fontSize: 14,
    fontFamily: 'NeoSansStd',
    fontWeight: 600,
    background: '#347AC4',
    borderRadius: 29,
    color: '#fff',
    '&.Mui-disabled': {
      color: '#fff',
      opacity: 0.5,
    },
  },
  icon: {
    marginRight: 5,
    fontSize: '1.3rem',
    color: '#fff',
  },
}));
